import { Component, OnInit } from '@angular/core';
import { color, language, ModalBase, notification } from 'curvy';
import { Task } from '@task-utils/types';
import { TaskRoutes } from '@task-utils/routes';
import { User } from '@task-modules/users';


@Component({
    selector: 'task-create-edit-label-flags-dialog',
    template: `
        <task-create-edit-label-flags [label_flag]="label_flag" (result)="handle_result($event)"></task-create-edit-label-flags>
    `
})
export class CreateEditLabelFlagsDialog extends ModalBase<Task.LabelFlags, Task.LabelFlags> implements OnInit {
    label_flag: Task.LabelFlags;

    ngOnInit() {
        this.label_flag = this.injectedData;
    }

    async handle_result(label_flag: Task.LabelFlags) {
        if (label_flag) {
            try {
                let prom: Promise<any>;
                let payload = { ...label_flag };

                if (!label_flag.label_id) {
                    prom = TaskRoutes.label_flags.api_label_flags_create(payload);
                } else {
                    prom = TaskRoutes.label_flags.api_label_flags_modify(this.injectedData.label_id, payload);
                }

                await prom;
                this.submit(label_flag);
            } catch (error) {
                if (error.internal_error_code === 4105) {
                    notification.show({
                        icon: 'error',
                        color: color.Variable.warn,
                        title: language.translate('ERROR'),
                        message: language.translate('LABEL.FLAG.ERROR.DUPLICATE_SHORT_NAME')
                    });
                    
                } else if (error.internal_error_code === 4001) {
                    notification.show({
                        icon: 'error',
                        color: color.Variable.warn,
                        title: language.translate('ERROR'),
                        message: language.translate('LABEL.FLAG.ERROR.COMPANY_REQUIRED')
                    })
                } else {
                    notification.show({
                        icon: 'error',
                        color: color.Variable.warn,
                        title: language.translate('ERROR'),
                        message: ''
                    });
                }
            }
        }
        else {
            this.submit(label_flag)
        }
    }
}
